import umit from "../icons/umit.webp";
import uncc from "../icons/uncc.png";
import ncat from "../icons/ncat.webp";
import scholarship from "../icons/scholarship.png";
// import codechef from "../icons/chandel shikha certi.pdf";
import wordpress from "../icons/Wordpress Coursera.pdf";
import hackathon from "../icons/NITManipurrank99.pdf";

const Educations = [
    {
        "college_url_name": "ncat",
        "college_title": "NC Agricultural & Technical State University",
        "college_degree": "Doctorate In Philosophy",
        "college_location": "Greensboro, USA",
        "start_date": "21/08/2025",
        "end_date": "10/05/2030",
        "image": ncat,
        "tech_stack": ["Artificial Intelligence", "Advanced Imaging", "Advanced Photogrammetry", "ARCGIS", "Remote Sensing", "Geographic Information Systems"],
        "grade": "3.9/4",
        "links": {
            "web_url": "https://www.aggies.ncat.edu/",
        },
        "major_contributions": [
            {
                "title": "Graduate Research Assistant for Leila GEMs Lab",
                "desc": "On-campus Job",
                "start_date": "21/08/2025",
                "end_date": "08/05/2026",
                "work_span": "Fall 2025 - Spring 2026",
                "web_url": "https://www.gemsinstitute.org/team",
            },
            {
                "title": "Paper Title: Bridging Spatial and Frequency Views for Disaster Assessment: Benefits and Limitations",
                "desc": "Conference Name: IGARSS 2026",
                "start_date": "Issue: Aug 2026",
                "end_date": "",
                "work_span": "7 Months",
                "web_url": "https://arxiv.org/pdf/2606.17403",
            },
            {
                "title": "Paper Title: A Unified Framework for Efficient Remote Sensing Visual Question Answering: Adapting Dual, Hybrid, and Encoder-Decoder Architectures",
                "desc": "IEEE IGARSS 2026 Conference Peer Reviewed publication",
                "web_url": "https://arxiv.org/abs/2606.19277",
            },
            {
                "title": "Paper Title: Comparison of Deep Learning Frameworks For Rice Disease Mapping From UAV Multispectral Imaging",
                "desc": "IEEE IGARSS 2026 Conference Peer Reviewed publication",
                "web_url": "https://arxiv.org/abs/2606.06359",
            },
          
        ],
        "brief":[
            " I am currently pursuing a Ph.D. in Applied Science and Technology at NC Agricultural & Technical State University, having started in Fall 2025. My research focuses on Artificial Intelligence, Remote Sensing, and Computer Vision. I work as a Graduate Research Assistant under Dr.Leila and have published research on disaster assessment using spatial and frequency views."
        ],
        "details": [
            "I am currently pursuing a Doctorate in Philosophy in Applied Science and Technology at NC Agricultural & Technical State University, having started in Fall 2025 (August 2025). My research focuses on <highlight>Artificial Intelligence and Remote Sensing.</highlight>",
            "As part of my academic journey, I have been working as a <highlight>Graduate Research Assistant</highlight> under Dr. Leila Hashemi-Beni since Fall 2025. In this role, I assist with research projects related to remote sensing, and artificial intelligence. This experience has allowed me to apply my technical skills in a practical research setting and contribute to ongoing projects.",
            "In addition to my research work, I have published a conference paper titled <highlight>BRIDGING SPATIAL AND FREQUENCY VIEWS FOR DISASTER ASSESSMENT: BENEFITS AND LIMITATIONS</highlight>, which will be presented at the IGARSS 2026 conference. This research explores the integration of spatial and frequency views for disaster assessment, highlighting the benefits and limitations of this approach.",
            "Also, I created a website for my lab, <a href=https://www.gemsinstitute.org/><highlight> GEMS LAB</highlight></a>, to showcase our research, projects, publications, news and involvement with the ASPRS community. This experience has enhanced my web development skills and allowed me to effectively communicate our research to a broader audience.",
            "With a combination of research experience, technical expertise, and academic achievements, I am committed to advancing my knowledge and contributing to the field of applied science and technology through my doctoral studies.",
        ]
    },
    {
        "college_url_name": "uncc",
        "college_title": "University Of North Carolina, Charlotte",
        "college_degree": "Masters In Science",
        "college_location": "Charlotte, USA",
        "start_date": "21/08/2023",
        "end_date": "10/05/2025",
        "image": uncc,
        "tech_stack": ["Machine Learning", "Knowledge Discovery In Databases", "Algorithms And Data Structures", "Software Design And Implementation", "Big Data and Analytics"],
        "grade": "3.8/4",
        "links": {
            "web_url": "https://www.charlotte.edu/",
        },
        "major_contributions": [
            {
                "title": "Graduate Teaching Assistant for ITCS_6150:Artificial Intelligence",
                "desc": "On-campus Job",
                "start_date": "22/08/2024",
                "end_date": "08/05/2025",
                "work_span": "Fall 2024 - Spring 2025",
                "web_url": "https://www.charlotte.edu/",
            },
            {
                "title": "AWS Academy Graduate - AWS Academy Data Engineering",
                "desc": "Certified Course",
                "start_date": "Issued: November 2024",
                "end_date": "",
                "work_span": "Fall 2024",
                "web_url": "https://www.credly.com/badges/9b88d358-1596-499b-98f1-d8bd96b8d7a4/linked_in_profile",
            },
            {
                "title": "Cashier",
                "desc": "On-campus Job",
                "start_date": "10/10/2023",
                "end_date": "08/05/2025",
                "work_span": "Fall 2023-Spring 2025",
                "web_url": "https://aux.charlotte.edu/directory/chartwells-dining-services/",
            },
            {
                "title": "Graduate Fellowship COIT Scholarship",
                "desc": "Scholarship",
                "start_date": "08/19/2024",
                "end_date": "05/08/2025",
                "work_span": "Fall 2024-Spring 2025",
                "web_url": scholarship,
            },
            {
                "title": "Movie Finder Project",
                "desc": "Capstone Project",
                "start_date": "06/01/2024",
                "end_date": "23/04/2024",
                "work_span": "Spring 2024",
                "web_url": "https://shikhachandelmoviefinder.netlify.app/",
            }
        ],
        "brief":[
            "I completed my Masters in Computer Science at UNC Charlotte (Intake: Fall 2023). I've completed courses in AI, Machine Learning, and Software Design. I developed a Movie Finder System as a capstone project. I've worked as a TA for AI under Dr. Dewan Ahmed and am an active TISA member."
        ],
        "details": [
            "I graduated from Master of Science in Computer Science at UNC Charlotte, having joined in Fall 2023 (August 2023). My coursework has provided me with a strong foundation in <highlight>Artificial Intelligence, Machine Learning, Algorithms and Data Structures, Data Information and Visualization, Data Mining, Large Language Models and Software System Design and Implementation.</highlight>",
            "As part of my academic journey, I have worked on several projects. One of my most notable projects is the <highlight>Movie Finder System</highlight>, developed as part of my capstone. This system allows users to track their watched and bookmarked movies while providing seamless access to IMDb's database for retrieving movie-related information. This project enhanced my skills in software development, database management, and user experience design.",
            "In addition to my academic work, I have gained valuable professional experience. I worked as a cashier at <highlight>Compass Group</highlight> for four semesters, where I developed strong communication and customer service skills, which have proven invaluable in team collaborations and professional interactions. Currently, I am serving as a <highlight>Graduate Teaching Assistant</highlight> for Artificial Intelligence under <highlight>Dr. Dewan Ahmed</highlight>, a role I have held for two semesters. In this position, I assist students with AI concepts, projects, and assignments, conduct office hours, and support grading and exam proctoring.",
            "Beyond academics and work experience, I am actively involved in student organizations. I am a member of the <highlight>TISA (Triveni Indian Student Association)</highlight>, which has provided opportunities for networking, cultural exchange, and community engagement.",
            "With a combination of academic excellence, hands-on projects, work experience, and active student involvement, I continue to expand my technical and interpersonal skills to excel in my career.",
        ]
    },
    {
        "college_url_name": "umit",
        "college_title": "Usha Mittal Institute Of Technology",
        "college_degree": "Bachelors In Technology",
        "college_location": "Mumbai, India",
        "start_date": "01/08/2018",
        "end_date": "07/06/2022",
        "image": umit,
        "tech_stack": ["Database Management System", "Object Oriented Programming In JAVA", "Data Structure And File Processing with C++", "Computer Architecture And Organization", "Operating Systems","Data Science And Business Analytics"],
        "grade": "9.6/10",
        "links": {
            "web_url": "https://www.umit.ac.in/about-umit",
        },
        "major_contributions": [
            {
                "title": "Paper Title: Stock Market Prediction Analysis",
                "desc": "Journal Name: International Research Journal of Engineering and Technology",
                "start_date": "Issue: Volume 9 Issue 4, April 2022",
                "end_date": "",
                "work_span": "6 Months",
                "web_url": "https://www.irjet.net/archives/V9/i4/IRJET-V9I4279.pdf",
            },
            {
                "title": "Digital Literacy Session",
                "desc": "Angel Xpress Foundation",
                "start_date": "2020",
                "end_date": "2020",
                "work_span": "2 Months",
                "web_url": "https://drive.google.com/file/d/1wXbJZ83pAqhwyNxjBOfpL2MIKLBePAoZ/view?usp=sharing",
            },
            // {
            //     "title": "Codechef-CODATHON",
            //     "desc": "Codechef UMIT",
            //     "start_date": "28/12/2020",
            //     "end_date": "29/11/2020",
            //     "work_span": "2 Day",
            //     "web_url": codechef,
            // },
            {
                "title": "Wordpress for blog creation",
                "desc": "Coursera",
                "start_date": "28/12/2020",
                "end_date": "29/12/2020",
                "work_span": "1 Day",
                "web_url": wordpress,
            },
            {
                "title": "Hackathon n Code Clash of D2C Online Hackathon Festival(OHF) Season 2",
                "desc": "Scored 99th rank allover India organised by National Institute of Technology(NIT), Manipur",
                "start_date": "30/12/2020",
                "end_date": "29/11/2021",
                "work_span": "1 Day",
                "web_url": hackathon,
            }
        ],
        "brief":[
            "I earned my B.Tech in Computer Science from Usha Mittal Institute of Technology in 2022. Proficient in C++, Java, Python, and more, I explored AI, ML, and data analysis. As a class representative and event organizer, I honed leadership skills. Projects on drowsiness detection and stock prediction enhanced my expertise."
        ],
        "details": [
            "I completed my Bachelor of Technology in Computer Science from Usha Mittal Institute of Technology in 2022.",
            "Throughout my studies, I gained proficiency in programming languages such as <highlight>C++, Visual Basic, Java, Python, HTML, and CSS</highlight>. My coursework included subjects like <highlight>Deep Learning, Machine Learning, Object-Oriented Programming, Compilers, Time Complexity Analysis, and Data Warehousing</highlight>, which provided a strong technical foundation.",
            "Beyond academics, I was actively involved in extracurricular activities. I served as a <highlight>Class Representative</highlight> during my first, third, and fourth years, developing <highlight>leadership</highlight> and <highlight>communication skills</highlight> while representing my peers. Additionally, I contributed to organizing Arcane Illusion, the largest cultural fest at our university, enhancing my <highlight>teamwork</highlight> and <highlight>event management</highlight> capabilities.",
            "I frequently participated in <highlight>hackathons</highlight> and coding competitions which strengthened my problem-solving abilities and technical expertise. In my third year, I worked on a <highlight>Drowsiness Detection</highlight> project, applying machine learning techniques to identify driver fatigue. For my final semester project, I collaborated on <highlight>Stock Market Prediction</highlight> using machine learning models, and our work was later published with the guidance of <highlight>Prof. Narendra Gawai</highlight>.",
            "These experiences have equipped me with strong technical skills, leadership qualities, and a passion for continuous learning.",
        ]
    }
]

export default Educations;
